import moment, { Moment } from 'moment-timezone'
import i18next from 'i18next'

export const getSprintEndPrefix = (end: Moment, timezone: string) => {
  const yesterdayByUserTimezone = moment.tz(timezone).subtract(1, 'days').format('YYYY-MM-DD')
  return yesterdayByUserTimezone === moment.utc(end).format('YYYY-MM-DD') ? i18next.t('user:Ended') : i18next.t('user:Ends')
}
